import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { buildReportPayload } from "../reports/reportUtils";
import API_URL from "../../config/ApiUrl";

export const getInvoiceReport = createAsyncThunk(
  "invoiceReport/getInvoiceReport",
  async (payload, { rejectWithValue }) => {
    try {
      const body = buildReportPayload(payload);
      const { data } = await axios.post(API_URL.INVOICE_REPORT.INVOICES, body);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getOutstandingInvoiceReport = createAsyncThunk(
  "invoiceReport/getOutstandingInvoiceReport",
  async (payload, { rejectWithValue }) => {
    try {
      const body = buildReportPayload(payload);
      const { data } = await axios.post(API_URL.INVOICE_REPORT.OUTSTANDING, body);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getInvoiceAgingReport = createAsyncThunk(
  "invoiceReport/getInvoiceAgingReport",
  async (payload, { rejectWithValue }) => {
    try {
      const body = buildReportPayload(payload);
      const { data } = await axios.post(API_URL.INVOICE_REPORT.AGING, body);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const initialState = {
  invoices: { list: [], total_records: 0, summary: null },
  outstandingInvoices: { list: [], total_records: 0 },
  invoiceAging: { list: [], total_records: 0, totals: null },
};

const invoiceReportSlice = createSlice({
  name: "invoiceReport",
  initialState,
  reducers: {
    resetInvoiceAgingReport: (state) => {
      state.invoiceAging = { list: [], total_records: 0, totals: null };
    },
    resetInvoiceReport: (state) => {
      state.invoices = { list: [], total_records: 0, summary: null };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInvoiceReport.fulfilled, (state, action) => {
        state.invoices.list = action.payload?.data?.list || [];
        state.invoices.total_records = action.payload?.data?.totalRecords || 0;
        state.invoices.summary = action.payload?.data?.summary || null;
      })
      .addCase(getOutstandingInvoiceReport.fulfilled, (state, action) => {
        state.outstandingInvoices.list = action.payload?.data?.list || [];
        state.outstandingInvoices.total_records = action.payload?.data?.totalRecords || 0;
      })
      .addCase(getInvoiceAgingReport.fulfilled, (state, action) => {
        state.invoiceAging.list = action.payload?.data?.list || [];
        state.invoiceAging.total_records = action.payload?.data?.totalRecords || 0;
        state.invoiceAging.totals = action.payload?.data?.totals || null;
      });
  },
});

export const { resetInvoiceAgingReport, resetInvoiceReport } = invoiceReportSlice.actions;
export default invoiceReportSlice.reducer;
